/** Organization slugs seeded in `LegalEntity`. */
export const ORG_SLUG = {
  WAPHARMA: 'wapharma',
  HAMSSAH: 'hamssah',
} as const;

export type OrgSlug = (typeof ORG_SLUG)[keyof typeof ORG_SLUG];

export type OrgEntityIds = {
  wapharmaId: string;
  hamssahId: string;
};

/** Default invoice/selling entity — Hamssah retail for all order channels. */
export function defaultOrderEntityIds(
  _channel: string,
  ids: OrgEntityIds,
): { sellingEntityId: string; invoiceEntityId: string } {
  return { sellingEntityId: ids.hamssahId, invoiceEntityId: ids.hamssahId };
}

/**
 * Stock owner entity for ATP by channel.
 * SHOWROOM = Hamssah local stock; ECOMMERCE = external WaPharma warehouse (dropship).
 */
export function stockOwnerSlugForChannel(channel?: string | null): OrgSlug {
  const ch = (channel ?? '').trim().toUpperCase();
  if (ch === 'SHOWROOM') return ORG_SLUG.HAMSSAH;
  return ORG_SLUG.WAPHARMA;
}

export type OrgWorkspace = 'hamssah-retail' | 'wapharma-ops';

export function workspaceForOrgSlug(slug: string | null | undefined): OrgWorkspace {
  return slug === ORG_SLUG.HAMSSAH ? 'hamssah-retail' : 'wapharma-ops';
}
